module.exports = __webpack_public_path__ + "img/pr-10.7d458349.png";